/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
 Form,
 Input,
 Modal,
 Row,
 Button,
 Popover,
 //  Tooltip,
} from 'antd'
import {
 TAddLeadEventBody,
 TLeadsNames,
 useAddLeadEventMutation,
 useUpdateLeadEventMutation,
} from 'features/leads'
import { baseTime } from 'lib'

import { FC, useEffect, useMemo, useState } from 'react'
import { TMode } from 'types'
import { checkIsDeferentTimeIsPast } from 'utils/functions'
import { TAddTask } from 'features/calendar'
import { BaseButton } from 'components/elements/BaseButton'
import useFetchPage from 'hooks/useFetchPage'
import { globalToaster } from 'components/elements/global'
import TaskFormBlock from './TaskFormBlock'
// import SelectLeadBlock from '../LoadMoreBlocks/SelectLeadBlock'

const AddTaskModal: FC<{
 onSuccess?: () => void
 editData?: TAddLeadEventBody
 mode?: TMode
 leadId?: any
 onCancel?: () => void
 visible?: boolean
 editableType?: 'single' | 'multiple'
 autoFocusTitle?: boolean
}> = ({
 onCancel,
 visible,
 leadId,
 mode = 'ADD',
 editData,
 onSuccess,
 editableType,
 autoFocusTitle = false,
}) => {
 const formInit: TAddTask = {
  // scheduled_at: baseTime().add(20, 'minute'),
  title: '',
  date: '',
  selected_type: 'daily',
  repeat_event: false,
  end_value_after: 1,
  end_type: 'after',

  weekly_days: [baseTime().format('dddd')],
  difference_month: 1,
  monthly_date: Number(baseTime().format('DD') ?? 1),
  selected_week: '1',
  monthly_selected_type: 'date',
  monthly_day: baseTime().format('dddd'),
  // end_value_specific: baseTime(`12-31-${baseTime().year()}`) as any,
 }

 const [addTask, { isLoading: addLoading }] = useAddLeadEventMutation()
 const [updateLeadEvent, { isLoading: updateLoading }] =
  useUpdateLeadEventMutation()

 const [searchKey, setSearchKey] = useState('')
 const { flatData, isLoading, hasMore, fetchMore } = useFetchPage<TLeadsNames>(
  'get-leads-name',
  {
   method: 'post',
   body: useMemo(
    () => ({
     search: searchKey,
    }),
    [searchKey],
   ),
  },
 )

 const [form] = Form.useForm<TAddTask>()
 const watch = Form.useWatch([], form)
 const handleSubmit = async () => {
  const {
   end_value_after,
   end_value_specific,
   weekly_days,
   selected_week,
   monthly_date,
   monthly_day,
   monthly_selected_type,
   selected_type,
   lead_id,
   ...values
  } = await form.validateFields()
  if (baseTime(values.scheduled_at).isBefore(baseTime())) {
   globalToaster({
    type: 'error',
    content: 'Please  select a valid date to continue',
   })
  } else {
   const postData: TAddTask & {
    feed: 'task' | 'appointment'
    lead_id?: string | number
    time: string
    date: string
   } = {
    ...values,
    date: baseTime(values.scheduled_at).format('YYYY-MM-DD'),
    time: baseTime(values.scheduled_at).format('HH:mm:ss'),
    lead_id: (lead_id as any)?.[0]?.id ?? leadId,
    feed: 'task',
    ...(watch?.repeat_event
     ? {
        selected_type,
        ...(selected_type === 'monthly'
         ? {
            selected_week,
            monthly_selected_type,
            ...(monthly_selected_type === 'date'
             ? { monthly_date }
             : { monthly_day }),
           }
         : {}),

        end:
         values?.end_type === 'after'
          ? `${end_value_after}`
          : baseTime(end_value_specific).format('YYYY-MM-DD'),
        weekly_days: JSON.stringify(weekly_days),

        ...(mode === 'EDIT'
         ? {
            editable: editableType,
            recurring_events_id: editData?.recurring_events_id,
           }
         : {}),
       }
     : {}),
   }
   if (mode === 'EDIT') {
    await updateLeadEvent({
     ...postData,
     id: editData?.id,
     // c,
    }).unwrap()
    onSuccess?.()
    form.resetFields()
    onCancel?.()
   } else {
    await addTask(postData).unwrap()
    form.resetFields()
    onSuccess?.()
    onCancel?.()
   }
  }
 }

 useEffect(() => {
  if (mode === 'EDIT' && editData) {
   const { recurring } = editData
   const dateTime = baseTime(`${editData.date} ${editData.time}`)
   form.setFieldsValue({
    title: editData.title,
    type: editData.type,
    scheduled_at: dateTime,
    ...(editData.reminder &&
    checkIsDeferentTimeIsPast(dateTime, editData.reminder)
     ? { reminder: editData.reminder }
     : {}),
    lead_id: [{ title: editData?.lead?.name, id: editData?.lead?.id }] as any,
    // lead_id: editData.lead_id,
    ...(editData?.is_recurring
     ? {
        repeat_event: editData?.is_recurring === 1,
        difference_month: recurring?.difference_month,
        selected_type: recurring?.selected_type,
        end_type: recurring?.end_type,
        monthly_selected_type: recurring?.monthly_selected_type ?? 'date',
        ...(recurring?.end_date && recurring?.end_type
         ? {
            end_value_after:
             recurring?.end_type === 'after' ? Number(recurring?.end_date) : 1,
            end_value_specific:
             recurring?.end_type === 'specific_date'
              ? (baseTime(recurring?.end_date) as any)
              : undefined,
           }
         : {}),
        ...(recurring?.selected_type === 'weekly' &&
         recurring?.weekly_days && {
          weekly_days: JSON.parse(recurring?.weekly_days ?? ''),
         }),
        ...(recurring?.selected_type === 'monthly' && {
         selected_week: recurring?.selected_week,
         monthly_day:
          recurring?.monthly_selected_type === 'day'
           ? recurring?.monthly_day
           : baseTime().format('dddd'),
         monthly_date:
          recurring?.monthly_selected_type === 'date'
           ? Number(recurring?.monthly_date ?? 0)
           : Number(baseTime().format('DD') ?? 1),
        }),
       }
     : {}),
   })
  } else {
   form.resetFields()
  }
  return () => {
   form.resetFields()
  }
 }, [editData, form, mode])

 return (
  <Modal
   forceRender
   confirmLoading={mode === 'EDIT' ? updateLoading : addLoading}
   onOk={handleSubmit}
   okText="Save"
   cancelButtonProps={{
    className: 'ant-btn ant-btn-default ant-btn-secondary secondary-btn',
   }}
   onCancel={onCancel}
   visible={visible}
   title={`${mode === 'EDIT' ? 'Edit' : 'Add'} Task`}
   className="add-task-modal"
   width={600}
  >
   <TaskFormBlock
    autoFocusTitle={autoFocusTitle}
    initialValues={formInit}
    isRecurringTask={editData?.is_recurring === 1}
    mode={mode}
    editableType={editableType}
    leadId={leadId}
    form={form}
   />
  </Modal>
 )
}

export default AddTaskModal
